import React from 'react';
import './Home.css';

function Home() {

  return (
    <div className="home-page">
      <header className="home-header">
        <h1 className="home-logo">Anatase</h1>
      </header>

      <main className="home-main">
        <div className="hero-section">
          <h2 className="hero-title">The governed semantic layer that grows itself</h2>
          <p className="hero-subtitle">
            Anatase builds your enterprise knowledge base on top of your own proprietary data — a
            living, governed semantic layer. Every answer is a curated, reproducible metric, and the
            knowledge base grows itself as new questions reveal what's missing, with a human
            approving every addition.
          </p>
        </div>

        <div className="features-section">
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                <polyline points="9 12 11 14 15 10"/>
              </svg>
            </div>
            <h3>Governed, reproducible answers</h3>
            <p>Ask in plain language and get governed metrics, not throwaway SQL. The same question
            returns the same trusted number — every time, for everyone.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                <polyline points="17 6 23 6 23 12"/>
              </svg>
            </div>
            <h3>Emergent &amp; self-growing</h3>
            <p>Anatase studies the questions people actually ask, finds what the semantic layer
            can't yet answer, and proposes the missing metrics automatically. The layer compounds
            with use.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
            </div>
            <h3>Human-in-the-loop governance</h3>
            <p>Every proposed metric — and its exact definition — is reviewed and approved before it
            goes live. No silent drift, no duplicate definitions: one source of truth that stays
            clean as it grows.</p>
          </div>
          <div className="feature">
            <div className="feature-icon">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <h3>Your enterprise knowledge base</h3>
            <p>Anatase runs on your own proprietary data and builds it into an enterprise knowledge
            base you own — capturing how your business actually defines and measures everything, not a
            generic, off-the-shelf model.</p>
          </div>
        </div>
      </main>

      <footer className="home-footer">
        <p>A governed, self-growing enterprise knowledge base built on your proprietary data.</p>
      </footer>
    </div>
  );
}

export default Home;
